<template>
  <v-data-table
    :headers="headers"
    :items="creditNotes"
    sort-by="date"
    class="elevation-1"
    sort-desc
    dense
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Notas de Crédito</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <div class="d-flex flex-row">
        <v-btn
          icon
          class="d-flex justify-center"
          :to="'/voucher/'+item.key"
        >
          <v-icon
            small
          >
            mdi-information
          </v-icon>
        </v-btn>
      </div>
    </template>
    <template
      v-slot:body.append
    >
      <tr>
        <td>
          Total notas de crédito
        </td>
        <td>
        </td>
        <td>
          {{totalAccountReceivable}}
        </td>
        <td>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
// import axios from 'axios'

export default {
  name: 'CustomerVouchers',
  props: [
    'creditNotes'
  ],
  components: {
  },
  data: () => ({
    voucher: null,
    amountOutstanding: null,
    dialog: false,
    loading: false,
    headers: [
      {
        text: 'Consecutivo',
        align: 'left',
        value: 'data.sequence'
      },
      { text: 'Fecha de emisión', value: 'data.date' },
      { text: 'Monto', value: 'data.summary.netTotal' },
      { text: 'Acciones', value: 'action', sortable: false }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      id: null,
      typeId: null,
      identification: null,
      name: null,
      email: null,
      phone: null,
      priceList: 'normal'
    },
    defaultItem: {
      id: null,
      typeId: null,
      identification: null,
      name: null,
      email: null,
      phone: null,
      priceList: 'normal'
    }
  }),

  computed: {
    totalAccountReceivable () {
      let total = 0
      this.creditNotes.forEach((note) => {
        total += Number(note.data.summary.netTotal)
      })
      return total
    },
    ...mapGetters('vouchers', [
      'getVouchers'
    ])
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  /* created () {
      this.initialize()
    }, */

  methods: {
    /* initialize () {
        this.items = this.getCompany.customers
      }, */
    newReceipt (item) {
      this.voucher = item.voucher
      this.amountOutstanding = item.amountOutstanding
      this.dialog = true
    },

    editItem (item) {
      this.editedIndex = this.getCustomers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      if (confirm('¿Estás seguro de que deseas eliminar este elemento?')) {
        this.deleteCustomer(item)
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.voucher = null
        this.amountOutstanding = null
      }, 300)
    },

    save () {
      this.loading = true
      this.insertCustomer(this.editedItem)
        .then(() => {
          setTimeout(() => {
            this.loading = false
            this.close()
          }, 3000)
        })
        // var companiesRef;
        /* db.collection("companies").where("identification", "==", this.getCompany.identification).get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                let companiesRef = doc.ref;
              if (this.editedIndex > -1) {
                companiesRef.update({
                  customers: fb.firestore.FieldValue.arrayRemove(this.getCompany.customers[this.editedIndex])
                });
                companiesRef.update({
                  customers: fb.firestore.FieldValue.arrayUnion(this.editedItem)
                });
                //Object.assign(this.items[this.editedIndex], this.editedItem)
              } else {
                companiesRef.update({
                  customers: fb.firestore.FieldValue.arrayUnion(this.editedItem)
                });
                //this.items.push(this.editedItem)
                //console.log(db.FieldValue)
              }
              this.close()
            });
        }); */
    },
    ...mapActions('customers', ['insertCustomer', 'deleteCustomer'])
  }
}
</script>
<style type="text/css">

</style>
